import React from "react";

export const Footer = () => {
  return (
    <div id="footer">
      <div>
        <a href="https://nikhil-sharma-portfolio.netlify.app/" target="_blank">
          Website
        </a>
        <a
          href="https://www.linkedin.com/in/nikhil-sharma-958a861b2/"
          target="_blank"
        >
          LinkedIn
        </a>
      </div>
    </div>
  );
};
